import SDDInstructions from 'components/FrictionlessCheckout/DeliverToReleaseThree/SDDInstructions/SDDInstructions';
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import OrderActions from 'actions/OrderActions';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import { orderDetailsSelector } from 'selectors/order/orderDetails/orderDetailsSelector';
import OrderUtils from 'utils/Order';
import Empty from 'constants/empty';
import SDDInstructionsEN from 'components/FrictionlessCheckout/DeliverToReleaseThree/SDDInstructions/locales/SDDInstructions_en_US';
import SDDInstructionsFR from 'components/FrictionlessCheckout/DeliverToReleaseThree/SDDInstructions/locales/SDDInstructions_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { saveDeliveryInstructions } = OrderActions;
const { getLocalisedDataFromResource, getTextFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(SDDInstructionsEN, SDDInstructionsFR);

const fields = createSelector(
    createStructuredSelector({
        title: getTextFromResource(getText, 'title'),
        textInputLabel: getTextFromResource(getText, 'textInputLabel'),
        deliveryNote: getTextFromResource(getText, 'deliveryNote'),
        optional: getTextFromResource(getText, 'optional'),
        cancel: getTextFromResource(getText, 'cancel'),
        saveInstructions: getTextFromResource(getText, 'saveInstructions'),
        edit: getTextFromResource(getText, 'edit')
    }),
    orderDetailsSelector,
    (locales, orderDetails) => {
        const { deliveryInstructions = '' } = OrderUtils.getSameDayShippingGroup(orderDetails) || Empty.Object;

        return {
            locales,
            deliveryInstructions
        };
    }
);

const functions = {
    saveDeliveryInstructions
};

const withSDDInstructionsProps = wrapHOC(connect(fields, functions));

const ConnectedDeliveryInstructions = withSDDInstructionsProps(SDDInstructions);

export default ConnectedDeliveryInstructions;
